import { trackingPageSettingsSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createTrackingPage = {
  name: "createTrackingPage" as const,
  input: z.object({ name: z.string() }),
  output: z.object({
    _id: zExt.objectId(),
    settings: trackingPageSettingsSchema,
  }),
};
